// extracted by mini-css-extract-plugin
export default {"textGradientMexico":"styles_textGradientMexico__ALVMr","glass":"styles_glass__8qce8"};